import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiExternalLink } from 'react-icons/fi';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [websites, setWebsites] = useState([]);
  const [activeClientsCount, setActiveClientsCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const { data, error } = await supabase.auth.getSession();
      if (error || !data.session) {
        navigate('/login');
      } else {
        setUser(data.session.user);
        setLoading(false);
      }
    };

    checkSession();
  }, [navigate]);

  useEffect(() => {
    if (!loading) {
      const fetchWebsites = async () => {
        const { data, error } = await supabase.from('websites').select('*');
        if (error) {
          console.error('Eroare la preluarea datelor:', error);
        } else {
          setWebsites(data);
          const uniqueOwners = new Set(data.map(site => site.owner).filter(Boolean));
          setActiveClientsCount(uniqueOwners.size);
        }
      };

      fetchWebsites();
    }
  }, [loading]);

  if (loading) return <Container className="mt-5">Se încarcă...</Container>;

  const regularWebsites = websites.filter(
    site =>
      !site.name.toLowerCase().includes('admin') &&
      !site.domain.toLowerCase().includes('admin')
  );

  const adminApps = websites.filter(
    site =>
      site.name.toLowerCase().includes('admin') ||
      site.domain.toLowerCase().includes('admin')
  );

  const renderCard = (site, index) => (
    <div key={index} className="neomorph-card mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <strong>{site.name}</strong>
        <a
          href={`https://${site.domain}`}
          target="_blank"
          rel="noopener noreferrer"
          title={`Vizitează ${site.domain}`}
          style={{ color: '#d6006b' }}
        >
          <FiExternalLink />
        </a>
      </div>
      <p className="mb-1">{site.domain}</p>
      <span className="neomorph-badge me-2">{site.technology}</span>
      <span className="neomorph-badge me-2">{site.uptime} % uptime</span>
      <span className="neomorph-badge">
        ultima actualizare: {site.last_updated}
      </span>
    </div>
  );

  return (
    <Container fluid className="neomorph-container">
      <h2 className="fw-bold mb-4">Dashboard</h2>

      {/* Statistici */}
      <Row className="g-4">
        <Col md={3}>
          <div className="neomorph-card">
            <h4>Total Proiecte</h4>
            <p className="fs-3">{websites.length}</p>
            <span className="neomorph-badge">+ față de luna trecută</span>
          </div>
        </Col>
        <Col md={3}>
          <div className="neomorph-card">
            <h4>Clienți Activi</h4>
            <p className="fs-3">{activeClientsCount}</p>
            <span className="neomorph-badge">+ client nou</span>
          </div>
        </Col>
        <Col md={3}>
          <div className="neomorph-card">
            <h4>Site-uri Offline</h4>
            <p className="fs-3">0</p>
            <span className="neomorph-badge text-danger">+0 față de ieri</span>
          </div>
        </Col>
      </Row>

      {/* Website-uri și aplicații */}
      <Row className="mt-5">
        <Col md={6}>
          <h4 className="mb-3">Website-uri Administrate</h4>
          {regularWebsites.length > 0 ? (
            regularWebsites.map(renderCard)
          ) : (
            <p className="text-muted">Niciun website adăugat.</p>
          )}
        </Col>

        <Col md={6}>
          <h4 className="mb-3">Aplicații Administrate</h4>
          {adminApps.length > 0 ? (
            adminApps.map(renderCard)
          ) : (
            <p className="text-muted">Nicio aplicație administrativă.</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
